import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import loadingButton from '@blade-sxp/record-center/components/buttons/loading-button.vue';
let default_1 = class default_1 extends Vue {
    exportRequest;
    async onButtonClick() {
        return new Promise((resolve, reject) => {
            this.exportRequest()
                .then((res) => {
                this.$alert(this.$t('common.csv').toString(), '', {
                    confirmButtonText: this.$t('common.confirm').toString(),
                    callback: (action) => {
                        if (action === 'confirm') {
                            if (res) {
                                window.location.href = process.env.NODE_ENV === 'development' ? `${res}` : res;
                            }
                        }
                        resolve();
                    },
                });
            })
                .catch(() => {
                reject(new Error());
            });
        });
    }
};
__decorate([
    Prop()
], default_1.prototype, "exportRequest", void 0);
default_1 = __decorate([
    Component({
        name: 'export-button',
        components: {
            loadingButton,
        },
        i18n: {
            messages: {
                'en-us': {},
                zh: {},
            },
        },
    })
], default_1);
export default default_1;
